import { SHOW_FLASH_EVENT, HIDE_FLASH_EVENT } from './flash_show';
import i18n from '../i18n';
const alertTemplate = document.createElement('template');
alertTemplate.innerHTML = `
  <div class="alert__inner_container test-alerts">
    <slot name="error"></slot>
    <slot name="info"></slot>
    <slot name="success"></slot>
    <slot name="sr_only"></slot>
  </div>
`;
class FlashAlert extends HTMLElement {
    constructor() {
        // Always call super first in constructor
        super();
        this.showMessage = (event) => {
            const flashDetail = event.detail;
            const { kind, text } = flashDetail;
            if (this.findExistingMessage(kind, text)) {
                return;
            }
            const message = document.createElement('flash-message');
            message.setAttribute('slot', kind);
            message.innerHTML = text;
            this.appendChild(message);
        };
        this.hideMessage = (event) => {
            const flashDetail = event.detail;
            const { kind, text } = flashDetail;
            const child = this.findExistingMessage(kind, text);
            if (child) {
                this.removeChild(child);
            }
        };
        const shadow = this.attachShadow({ mode: 'open' });
        const templateClone = alertTemplate.content.cloneNode(true);
        const wrapper = templateClone.querySelector('.alert__inner_container');
        if (this.hasAttribute('backend') && wrapper) {
            wrapper.className += ' alert__inner_container--backend';
        }
        shadow.appendChild(templateClone);
    }
    connectedCallback() {
        this.className = 'alert__container';
        this.setAttribute('role', 'complementary');
        this.setAttribute('aria-label', i18n.$gettext('Alerts'));
        const stylesheetLinks = document.querySelectorAll('.steady_stylesheet');
        stylesheetLinks.forEach(link => {
            var _a;
            const linkCopy = link.cloneNode(true);
            (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.appendChild(linkCopy);
        });
        window.steadyFlashEventListenerInstalled = true;
        window.addEventListener(SHOW_FLASH_EVENT, this.showMessage);
        window.addEventListener(HIDE_FLASH_EVENT, this.hideMessage);
    }
    disconnectedCallback() {
        window.steadyFlashEventListenerInstalled = false;
        window.removeEventListener(SHOW_FLASH_EVENT, this.showMessage);
        window.removeEventListener(HIDE_FLASH_EVENT, this.hideMessage);
    }
    findExistingMessage(kind, text) {
        for (const child of this.children) {
            const childKind = child.getAttribute('slot');
            const childText = child.getAttribute('data-text');
            if (childKind === kind && childText === text) {
                return child;
            }
        }
    }
}
customElements.define('flash-alert', FlashAlert);
const closeButton = `
  <button class="alert__close_button test-close_alert">
    <span class="sr_only">${i18n.$gettext('Dismiss alert')}</span>
    <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.92888 0.707107C1.3194 0.316582 1.95257 0.316583 2.34309 0.707107L15.071 13.435C15.4615 13.8256 15.4615 14.4587 15.071 14.8492C14.6805 15.2398 14.0473 15.2398 13.6568 14.8492L0.92888 2.12132C0.538355 1.7308 0.538355 1.09763 0.92888 0.707107Z" fill="#585266"></path>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.928909 14.8492C0.538384 14.4587 0.538384 13.8255 0.928909 13.435L13.6568 0.707061C14.0474 0.316537 14.6805 0.316537 15.071 0.707061C15.4616 1.09759 15.4616 1.73075 15.071 2.12127L2.34312 14.8492C1.9526 15.2397 1.31943 15.2397 0.928909 14.8492Z" fill="#585266"></path>
    </svg>
  </button>
`;
const makeClass = (type) => `alert alert--${type} test-alert test-alert--${type}`;
const errorTemplate = document.createElement('template');
errorTemplate.innerHTML = `
  <div class="${makeClass('error')}">
    <div class="alert__message">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="info_icon">
        <circle cx="10" cy="10" r="9.5" fill="white" fill-opacity="0.5" stroke="none" class="info_icon__circle"></circle>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0001 7.34998C10.3591 7.34998 10.6501 7.64099 10.6501 7.99998L10.6501 16C10.6501 16.359 10.3591 16.65 10.0001 16.65C9.64111 16.65 9.3501 16.359 9.3501 16L9.3501 7.99998C9.3501 7.64099 9.64111 7.34998 10.0001 7.34998Z" fill="none" class="info_icon__letter"></path>
        <circle cx="10" cy="5" r="1" fill="none" class="info_icon__letter"></circle>
      </svg>
    </div>
    ${closeButton}
  </div>
`;
const infoTemplate = document.createElement('template');
infoTemplate.innerHTML = `
  <div class="${makeClass('info')}">
    <div class="alert__message">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="info_icon">
        <circle cx="10" cy="10" r="9.5" fill="white" fill-opacity="0.5" stroke="none" class="info_icon__circle"></circle>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0001 7.34998C10.3591 7.34998 10.6501 7.64099 10.6501 7.99998L10.6501 16C10.6501 16.359 10.3591 16.65 10.0001 16.65C9.64111 16.65 9.3501 16.359 9.3501 16L9.3501 7.99998C9.3501 7.64099 9.64111 7.34998 10.0001 7.34998Z" fill="none" class="info_icon__letter"></path>
        <circle cx="10" cy="5" r="1" fill="none" class="info_icon__letter"></circle>
      </svg>
    </div>
    ${closeButton}
  </div>
`;
const successTemplate = document.createElement('template');
successTemplate.innerHTML = `
  <div class="${makeClass('success')}">
    <div class="alert__message">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="9.5" fill="white" fill-opacity="0.5" stroke="url(#paint0_linear_205_2295)"></circle>
        <path d="M7.33562 14.7507C7.35326 14.7753 7.37293 14.7988 7.39461 14.821C7.62742 15.0597 8.00488 15.0597 8.23769 14.821L15.8254 7.04319C16.0582 6.80454 16.0582 6.41763 15.8254 6.17898C15.5926 5.94034 15.2151 5.94034 14.9823 6.17898L7.81603 13.5248L5.01769 10.6564C4.78488 10.4177 4.40742 10.4177 4.17461 10.6564C3.9418 10.895 3.9418 11.2819 4.17461 11.5206L7.26609 14.6895C7.28806 14.7121 7.31132 14.7324 7.33562 14.7507Z" fill="url(#paint1_linear_205_2295)"></path>
        <defs>
          <linearGradient id="paint0_linear_205_2295" x1="25.1092" y1="-4.63768" x2="-6.39389" y2="-1.95786" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#6FCF97"></stop>
            <stop offset="1" stop-color="#99D07F"></stop>
          </linearGradient>
          <linearGradient id="paint1_linear_205_2295" x1="19.0655" y1="3.91305" x2="0.268693" y2="6.04499" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#6FCF97"></stop>
            <stop offset="1" stop-color="#99D07F"></stop>
          </linearGradient>
        </defs>
      </svg>
    </div>
    ${closeButton}
  </div>
`;
const srOnlyTemplate = document.createElement('template');
srOnlyTemplate.innerHTML = `
  <div class="${makeClass('sr_only')}">
    <div class="alert__message"></div>
    ${closeButton}
  </div>
`;
const templates = {
    error: errorTemplate,
    info: infoTemplate,
    success: successTemplate,
    sr_only: srOnlyTemplate
};
class FlashMessage extends HTMLElement {
    connectedCallback() {
        // Create internal structure in regular DOM
        // needs to be done in the callback so it can be added programmatically
        const type = this.getAttribute('slot');
        if (type === 'error' || type === 'success' || type === 'info' || type === 'sr_only') {
            const templateClone = templates[type].content.cloneNode(true);
            const messageHTML = this.innerHTML;
            // set contents as attribute to easily identify identical messages
            this.setAttribute('data-text', messageHTML);
            const closeButton = templateClone.querySelector('.alert__close_button');
            closeButton === null || closeButton === void 0 ? void 0 : closeButton.addEventListener('click', () => this.remove());
            const message = templateClone.querySelector('.alert__message');
            if (message) {
                message.innerHTML += messageHTML;
            }
            this.replaceChildren(templateClone);
        }
    }
    disconnectedCallback() {
        const closeButton = this.querySelector('.alert__close_button');
        closeButton === null || closeButton === void 0 ? void 0 : closeButton.removeEventListener('click', () => this.remove());
    }
}
customElements.define('flash-message', FlashMessage);
